<template>
  <v-dialog :value="dialogProp.show" persistent max-width="600">
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-toolbar-title>
          {{ $t('Добавление банковских реквизитов') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <ValidationObserver ref="addForm">
        <v-card-text class="pt-3">
          <v-row>
            <v-col cols="12">
              <text-view
                  :display="dialogProp.accountType
                    ? $t(BANK_ACCOUNT_TYPES_ENUM[dialogProp.accountType])
                    : null"
                  multiline
                  :label="$t('Тип счета')" />
              <!-- <federal-bank-account
                  v-if="isFederal"
                  ref="bankAccount"
                  :save-method="save" /> -->
              <credit-org-bank-account
                  v-if="isCreditOrg"
                  ref="bankAccount"
                  :bank-account="bankAccountCredit"
                  @input="changeBankAccountCreditField" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
              id="cancelBtn"
              v-test="{ btn: 'cancel' }"
              color="primary"
              @click.stop="close">
            {{ $t('Отмена') }}
          </v-btn>
          <v-btn
              id="saveBtn"
              v-test="{ btn: 'save' }"
              color="primary"
              :disabled="isLoading"
              @click.stop="save">
            {{ $t('Сохранить') }}
          </v-btn>
        </v-card-actions>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
  import Vue from 'vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import CreditOrgBankAccount from './CreditOrgBankAccount.vue'
  // import FederalBankAccount from './FederalBankAccount.vue'
  import TextView from '@/components/reused/ui/TextView.vue'
  import { BANK_ACCOUNT_TYPES_ENUM } from '@/constants/enums.js'
  import { BANK_ACCOUNT_TYPES, DICTIONARY_TYPES } from '@/constants/business'

  export default {
    components: {
      GeneralError,
      CreditOrgBankAccount,
      // FederalBankAccount,
      TextView
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => ({
          show: false,
          accountType: null,
          callback: null
        })
      }
    },
    data () {
      return {
        isLoading: false,
        BANK_ACCOUNT_TYPES_ENUM,
        DICTIONARY_TYPES,
        bankAccountCredit: {
          bankName: null,
          bik: null,
          correspondentAccount: null,
          personalAccount: null
        }
      }
    },
    computed: {
      isFederal () {
        return this.dialogProp.accountType === BANK_ACCOUNT_TYPES.FEDERAL
      },
      isCreditOrg () {
        return this.dialogProp.accountType === BANK_ACCOUNT_TYPES.CREDIT
      },
      title () {
        return this.isCreditOrg
          ? this.$t('Счет в кредитной организации')
          : this.isFederal
            ? this.$t('Счет в территориальном органе Федерального казначейства/финансовом органе субъекта РФ или муниципальном образовании')
            : null
      }
    },
    methods: {
      changeBankAccountCreditField: async function ({ property, value }) {
        this.bankAccountCredit[property] = value
      },
      save: async function () {
        try {
          const isValidated = await this.$refs.bankAccount.validate()
          if (!isValidated) {
            throw new Vue.errorsTypes.ValidationError()
          }
          if (this.dialogProp.callback) {
            const model = {
              bankAccount: this.isCreditOrg ? { ...this.bankAccountCredit } : null,
              accountType: this.dialogProp.accountType
            }
            this.isLoading = true
            await this.dialogProp.callback(model)
            this.isLoading = false
          }
          this.close()
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      close: function () {
        this.$emit('close')
      }
    }
  }
</script>
